module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-json-tree/~/babel-runtime/core-js/object/assign.js
// module id = 1485
// module chunks = 0